
import Vue from 'vue'
import store from './store'
import axios from 'axios'
import VueCookies from 'vue-cookies';
import VueMask from 'v-mask'

import modules from './modules/module';
import widgets from './widgets/widget';
import workers from './workers/worker';
import service from './service/main';
import VTooltip from 'v-tooltip'

/* document.addEventListener('DOMContentLoaded', e => {
  console.log(document.getElementById('app'))
}) */
//Vue.use(VueAppend)
Vue.prototype.$axios = axios.create({
  baseURL: 'https://rest.onegin.land/api',
})

Vue.config.productionTip = false
Vue.use(VueCookies);
Vue.use(VueMask);
Vue.use(VTooltip)
let components = {
  ...modules,
}

let vm = '';
let render = () => {

   vm = new Vue({
    store,
    el: '#app',
    components,
  }).$mount()
}


setTimeout(() => {
  render()
}, 2000)

